import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    height: "100%",
    maxHeight: "100%",
    minHeight: 0,
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
    borderRadius: "18px 0 0 0",
    border: "none",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      borderRadius: 0,
      border: "none",
      boxShadow: "none",
    },
  },

  chatPapper: {
    display: "flex",
    height: "100%",
    minHeight: 0,
    backgroundColor: theme.palette.background.paper,
    borderRadius: "18px 0 0 0",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      borderRadius: 0,
    },
  },

  contactsWrapper: {
    display: "flex",
    height: "100%",
    minHeight: 0,
    flexDirection: "column",
    overflowY: "hidden",
  },
  contactsWrapperSmall: {
    display: "flex",
    height: "100%",
    minHeight: 0,
    flexDirection: "column",
    overflowY: "hidden",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    minHeight: 0,
    flexDirection: "column",
  },
  messagessWrapperEmpty: {
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  welcomeMsg: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
  },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const Chat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
        <Grid container spacing={0}>
          {/* <Grid item xs={4} className={classes.contactsWrapper}> */}
          <Grid
            item
            xs={12}
            md={4}
            className={
              ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <TicketsManager />
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            className={`${classes.messagessWrapper} ${!ticketId ? classes.messagessWrapperEmpty : ""}`}
          >
            {/* <Grid item xs={8} className={classes.messagessWrapper}> */}
            {ticketId ? (
              <>
                <Ticket />
              </>
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg}>
                  {/* <Paper square variant="outlined" className={classes.welcomeMsg}> */}
                  <span>{i18n.t("chat.noTicketMessage")}</span>
                </Paper>
              </Hidden>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Chat;
